import { Col } from "react-bootstrap";

const FooterColumns = ({ columns, footerColumns, handleShowMore }) => {
	const columnLinkLimit = 17,
		isShowMoreEnabled = false;

	return (
		<>
			{footerColumns?.length &&
				columns?.map((column, index) => (
					<Col
						sm={4}
						md={4}
						xl={2}
						lg={2}
						key={`col-${column.id}-${column.title}`}
					>
						<div className="footer-col">
							<div className="footer-col-title">
								<p className=" text-medium font-semibold">{column.title}</p>
							</div>
							<div className="footer-col-link">
								<ul>
									{column.links
										.slice(0, 16)
										.map((link, linkIndex) => (
											<li
												key={`Link-${link.label}`}
												className={
													!footerColumns[index]
														?.seeMore &&
													linkIndex > columnLinkLimit
														? "d-none"
														: ""
												}
											>
												<a href={link?.href}>
													{link?.label}

													{link.href == "careers" ? (
														<span className="tag-line">
															We are Hiring!
														</span>
													) : (
														<></>
													)}
													{link.href == "/careers" ? (
														<span className="tag-line">
															We are Hiring!
														</span>
													) : (
														<></>
													)}
												</a>
											</li>
										))}
									{isShowMoreEnabled &&
										footerColumns[index].colLength - 1 >
											columnLinkLimit && (
											<li
												key="see-more-btn"
												className="see-more-btn"
											>
												<div
													onClick={() =>
														handleShowMore(index)
													}
												>
													{footerColumns[index]
														.seeMore
														? "See Less"
														: "See More"}
												</div>
											</li>
										)}
								</ul>
							</div>
						</div>
					</Col>
				))}
		</>
	);
};

export default FooterColumns;

